module.exports = __webpack_public_path__ + "static/media/news-timesunion.734c3bba.jpg";